import React, { useState } from 'react';
import { TextField, Typography } from '@mui/material';
import ConfirmActionDialog from './ConfirmActionDialog';
import { useHasChanged } from '@hooks/useHasChanged';

interface RejectDeviceDialogProps {
  open: boolean;
  deviceName?: string;
  isRejecting: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

/** Confirmation dialog that collects a rejection reason for a device. */
const RejectDeviceDialog: React.FC<RejectDeviceDialogProps> = ({
  open,
  deviceName,
  isRejecting,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState('');

  // Reset only once the dialog is fully dismissed, so a failed reject (dialog
  // stays open) keeps the typed reason for a retry.
  if (useHasChanged(open) && !open) setReason('');

  return (
    <ConfirmActionDialog
      open={open}
      title="Reject Device"
      confirmLabel="Reject Device"
      loadingLabel="Rejecting..."
      isLoading={isRejecting}
      confirmDisabled={!reason.trim()}
      onClose={onClose}
      onConfirm={() => onConfirm(reason.trim())}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>
        Please provide a reason for rejecting {deviceName}:
      </Typography>
      <TextField
        autoFocus
        multiline
        rows={3}
        fullWidth
        label="Rejection Reason"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Enter the reason for rejecting this device..."
      />
    </ConfirmActionDialog>
  );
};

export default RejectDeviceDialog;
